import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/components/Landing";
import Login from "@/components/Login";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import Overview from "@/components/Overview";
import NetworkScan from "@/components/NetworkScan";
import IPTracker from "@/components/IPTracker";
import Alerts from "@/components/Alerts";
import Reports from "@/components/Reports";
import Settings from "@/components/Settings";
import Support from "@/components/Support";
import ForensicReports from "@/components/ForensicReports";
import LoginAttempts from "@/components/LoginAttempts";
import AdminDashboard from "@/components/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Synchronous check (NOT in useEffect) — handles OAuth fragment before
  // ProtectedRoute or AuthProvider tries to verify the session.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <Layout><Overview /></Layout>
          </ProtectedRoute>
        }
      />
      <Route path="/app/scan" element={<ProtectedRoute><Layout><NetworkScan /></Layout></ProtectedRoute>} />
      <Route path="/app/ip-tracker" element={<ProtectedRoute><Layout><IPTracker /></Layout></ProtectedRoute>} />
      <Route path="/app/alerts" element={<ProtectedRoute><Layout><Alerts /></Layout></ProtectedRoute>} />
      <Route path="/app/login-attempts" element={<ProtectedRoute><Layout><LoginAttempts /></Layout></ProtectedRoute>} />
      <Route path="/app/forensic-reports" element={<ProtectedRoute><Layout><ForensicReports /></Layout></ProtectedRoute>} />
      <Route path="/app/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
      <Route path="/app/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
      <Route path="/app/support" element={<ProtectedRoute><Layout><Support /></Layout></ProtectedRoute>} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute requireRole="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                border: "1px solid #1f1f1f",
                color: "#fff",
                fontFamily: "'Azeret Mono', monospace",
                fontSize: 12,
                borderRadius: 2,
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
